function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.41001 11H21C21.2652 11 21.5196 11.1054 21.7071 11.2929C21.8947 11.4804 22 11.7348 22 12C22 12.2652 21.8947 12.5196 21.7071 12.7071C21.5196 12.8946 21.2652 13 21 13H5.41001L10.71 18.3C10.8726 18.4924 10.9565 18.7392 10.945 18.9908C10.9336 19.2425 10.8275 19.4805 10.6482 19.6574C10.4688 19.8343 10.2292 19.9369 9.97743 19.9448C9.72563 19.9527 9.48013 19.8653 9.29001 19.7L2.29001 12.7C2.10678 12.5131 2.00415 12.2618 2.00415 12C2.00415 11.7382 2.10678 11.4869 2.29001 11.3L9.29001 4.3C9.48013 4.13472 9.72563 4.04729 9.97743 4.05519C10.2292 4.06308 10.4688 4.16573 10.6482 4.34259C10.8275 4.51946 10.9336 4.75752 10.945 5.00918C10.9565 5.26083 10.8726 5.50755 10.71 5.7L5.40001 11H5.41001Z"
});

var SvgLeftArrow = function SvgLeftArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLeftArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/left-arrow.4fbc8c38.svg";
export { ForwardRef as ReactComponent };